import { createSelector } from 'reselect';
import routingSelector from 'selectors/routingSelector';

const routeRegex = /\/([^\/]*)\/?.*/;
export default createSelector(
    routingSelector,
    (routing) => {
        const { locationBeforeTransitions: { pathname = '' } = {} } = routing;
        const matches = pathname.match(routeRegex) || [];
        if (matches[1]) {
            return matches[1];
        }
        return null;
    }
);



// WEBPACK FOOTER //
// ./app/selectors/routeSelector.js